module.exports = require('./lib/core');